const MAX_LENGTH = 80

export const getOrCreateDivPortal = () => {
    let portalDiv = document.querySelector("#draggable-portal")
    if (portalDiv) return portalDiv

    portalDiv = document.createElement("div")
    portalDiv.id = "draggable-portal"
    document.body.appendChild(portalDiv)

    return portalDiv
}
